import { render, staticRenderFns } from "./MontageTeamsSection.vue?vue&type=template&id=d44f54b4&scoped=true"
import script from "./MontageTeamsSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./MontageTeamsSection.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MontageTeamsSection.vue?vue&type=style&index=0&id=d44f54b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d44f54b4",
  null
  
)

export default component.exports